<template>

<div>

    <h1>New booking</h1>

    <Errors/>

    <BookingSummary :booking="booking"></BookingSummary>

    <BookingItems 
      :booking="booking"
      :tour_bookings="booking.tour_bookings" 
      :tours-total-price="toursTotalPrice" 
      :passengers="(booking.passengers) ? booking.passengers : []" 
      :multiple-bookables="multipleBookables" 
      v-if="booking.tour_bookings.length > 0" />

    <div class="box" v-if="booking.tour_bookings.length > 0">
      <div class="wrap row w-100">
        <div class="col-4 mb-4" v-if="showCustomAirlineSwitch">
          <label for="custom_airline_ref_email" class="fw-bold">Custom airline reference email</label><br>
          <label class="switch mt-1">
            <input id="custom_airline_ref_email" type="checkbox" v-model="customAirlineRefEmail" @change="resetAirlineRefEmail"/>
            <span class="switch__slider"></span>
          </label>
        </div>

        <div class="col-4 mb-4" v-if="customAirlineRefEmail && showCustomAirlineSwitch">
          <label class="fw-bold">Allowed domain</label><br>
          <v-select v-model="booking.allowed_domain" :options="['mehmail.co.uk']" @change="bindAirlineRefEmail"></v-select>
        </div>

        <div class="col-4 mb-4" v-if="customAirlineRefEmail || !showCustomAirlineSwitch">
          <label class="fw-bold">Airline reference email</label><br>
          <input class="form-control" type="text" v-model="booking.airline_reference_email">
        </div>
      </div>
    </div>

    <button v-if="booking.customer !== null || booking.agent !== null" class="mt-1 button" v-on:click="selectingTours = true">Add tour to booking</button>
    <div class="modal" v-if="selectingTours == true" style="display: block;">
      <BookingTourSelect :booking="booking"></BookingTourSelect>
      <button type="button" class="icon icon--unlink" v-on:click="selectingTours = false">Close</button>
    </div>
    <div class="modal__bg" v-if="selectingTours == true"></div>

    <div v-if="(booking.customer !== null || booking.agent !== null) && booking.tour_bookings.length > 0" style="margin-top: 1rem;display:flex;justify-content:flex-end">
      <button  class="button" v-on:click="createBooking">Proceed with booking</button>
    </div>

</div>

</template>

<script>
import 'datatables.net'
import {mapGetters} from 'vuex'
import Errors from '@/components/Errors.vue'
import BookingSummary from '@/components/BookingSummary.vue'
import BookingItems from '@/components/BookingItems.vue'
import BookingTourSelect from '@/components/BookingTourSelect.vue'

export default {
  name: 'BookingCreate',
  components: {
    Errors,
    BookingSummary,
    BookingItems,
    BookingTourSelect,
  },
  computed: {
    ...mapGetters(['getLoadStatus']),
    toursTotalPrice: function() {
      let total = 0
      if(this.booking.tour_bookings.length > 0) {
        for(const tour_booking of this.booking.tour_bookings) {
          if(tour_booking.sale_price !== null) {
            total += (tour_booking.sale_price * tour_booking.guests)
          } else {
            total += (tour_booking.price * tour_booking.guests)
          }
        }
      }
      return total
    },
    multipleBookables() {
      if(this.booking.tour_bookings.length > 1) {
        return true
      } else {
        return false
      }
    }
  },
  data () {
    return {
      errors: null,
      booking: {
        customer: null,
        agent: null,
        affiliate: null,
        tour_bookings: [],
        allowed_domain: null,
        airline_reference_email: null
      },
      selectingTours: false,
      customAirlineRefEmail: false,
      showCustomAirlineSwitch: true
    }
  },
  methods: {
    createBooking () {
      let departure_date = this.booking.tour_bookings[0].instance.departure_date;
      for (let i = 1, len=this.booking.tour_bookings.length; i < len; i++) {
        let v = this.booking.tour_bookings[i].instance.departure_date;
        departure_date = (v < departure_date) ? v : departure_date;
      }

      var tourBookingRequest = []
      for (let item of this.booking.tour_bookings) {
        // let price = item.adjusted_price
        // if(item.sale_price !== null) price = item.sale_price
        // // console.log(price); return;

        var tour_booking = {
          tour_id: item.tour.id,
          tour_instance_id: item.tour_instance_id,
          tour_room_id: item.tour_room_id,
          rooms: item.rooms,
          guests: item.guests,
          price: item.price,
          cost: item.cost,
          airline_ref: item.airline_ref,
          airline_flight_cost: item.airline_flight_cost,
          selected_multiple_room: item.selected_multiple_room ? item.selected_multiple_room : null
        }
        tourBookingRequest.push(tour_booking)
      }

      var bookingRequest = {
        customer_id: (this.booking.customer) ? this.booking.customer.id : null,
        agent_id: this.booking.agent ? this.booking.agent.id : null,
        affiliate_id: this.booking.affiliate ? this.booking.affiliate.id : null,
        tour_bookings: tourBookingRequest,
        departure_date: departure_date,
        airline_reference_email: this.booking.airline_reference_email,
        flight_budget_cost: this.booking.tour_bookings[0].instance.budgeted_cost
      }

      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'bookings', {
        method: 'POST',
        body: JSON.stringify(bookingRequest),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success) {
          this.$router.push({ name: 'booking-edit', params: { id: response.data.id }})
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });

    },
    bindAirlineRefEmail() {
      if(this.booking.allowed_domain) {
        this.booking.airline_reference_email = `${this.booking.customer.first_name.toLowerCase()}.${this.booking.customer.last_name.toLowerCase()}@${this.booking.allowed_domain}`
      } else {
        this.booking.airline_reference_email = null;
      }
    },
    resetAirlineRefEmail() {
      if(!this.customAirlineRefEmail) {
        this.booking.airline_reference_email = null;
        this.booking.allowed_domain = null;
      }
    }
  }
}


</script>
